import React from "react";
import { useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import GlobalSidebarMenu from "../../default/header/globalSidebarMenu";

const SidebarMenu = () => {
    const location = useLocation();
    const isActive = (hash) => location.hash === hash ? 'active-menu' : '';
    const isLeadNewPath = location.pathname === '/lead/new' && (!location.hash || location.hash === '#basic-info');
    // Scroll with offset function for HashLink
    const scrollWithOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -80; 
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    };
    return (
        <div className="card-menu-wrapper">
            <div className="sticky-area has-top-level-menu">
                <div className="top-level-menu">
                    <GlobalSidebarMenu sidebarTitle=" " />
                </div>
                <ul>
                    <li><HashLink smooth scroll={scrollWithOffset} className={isLeadNewPath ? 'active-menu' : ''} to="#basic-info">Basic Info</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset} className={isActive('#email-section')} to="#email-section">Email</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset} className={isActive('#phone-section')} to="#phone-section">Phone</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset} className={isActive('#website-section')} to="#website-section">Websites</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset} className={isActive('#address-section')} to="#address-section">Address</HashLink></li>
                    <li><HashLink smooth scroll={scrollWithOffset} className={isActive('#notes-section')} to="#notes-section">Notes</HashLink></li>
                </ul>
            </div>
        </div>
    );
};

export default SidebarMenu;

